/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TournamentTeam = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        image: {
            type: 'any-of',
            contains: [{
                type: 'Image',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        groups: {
            type: 'array',
            contains: {
                type: 'TournamentGroupStanding',
            },
            isRequired: true,
        },
    },
} as const;
